import React from 'react';
import { Provider } from 'react-redux';

import { ConfigProvider } from 'ha/helpers/config';
import { IntlProvider } from 'ha/i18n';
import { ServicesProvider } from 'ha/services/ServicesContext';
import { AppServices } from 'ha/services/getAppServices';
import theme from 'ha/theme';
import { ThemeProvider } from '@material-ui/core';
import { Store } from 'redux';
import { Config } from 'ha/config';
import { IntlObject } from 'ha/i18n/types';
import ErrorBoundary from 'ha/components/ErrorBoundary';

interface Props {
  store: Store;
  config: Config;
  intl: IntlObject;
  services: AppServices;
}

const AppContextProvider: React.FC<Props> = ({
  store,
  config,
  intl,
  services,
  children,
}) => (
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <ConfigProvider value={config}>
        <ServicesProvider value={services}>
          <IntlProvider value={intl}>
            <ErrorBoundary>{children}</ErrorBoundary>
          </IntlProvider>
        </ServicesProvider>
      </ConfigProvider>
    </Provider>
  </ThemeProvider>
);

export default AppContextProvider;
